var path = require('path');
var fs = require('fs');
function Localize(translations, dateFormats, defaultLocale) {
  defaultLocale = typeof defaultLocale === "string" ? defaultLocale : "eng";
  var locale = defaultLocale;
  var missingTranslationThrow = true;
  function mergeObjs() {
    var outObj = {};
    for (var i in arguments) {
      if (arguments[i] instanceof Object) {
        for (var j in arguments[i]) {
          outObj[j] = arguments[i][j];
        }
      }
    }
    return outObj;
  }
  this.setLocale = function (newLocale) {
    if (typeof newLocale === "string") {
      locale = newLocale;
    } else {
      throw new Error("Locale must be a string");
    }
  };
  this.getLocale = function () {
    return locale;
  };
  this.strings = {};
  function getTranslations(currDir, translations, strings) {
    if (fs.existsSync(currDir)) {
      if (fs.existsSync(path.join(currDir, "translations.json"))) {
        translations = mergeObjs(translations, JSON.parse(fs.readFileSync(path.join(path.resolve(currDir), "translations.json"))));
      }
      var pathChildren;
      var translationPath = path.join(currDir, "translations");
      if (fs.existsSync(translationPath) && fs.statSync(translationPath).isDirectory()) {
        pathChildren = fs.readdirSync(translationPath);
        pathChildren.filter(function (child) {
          return !/^.*\..*\..*/.test(child);
        }).map(function (child) {
          return {
            name: child.replace(/\..*$/, ""),
            defaultText: fs.readFileSync(path.join(translationPath, child), 'utf8'),
            translations: pathChildren.filter(function (secondChild) {
              return new RegExp("^" + child.replace(/\..*$/, "")).test(secondChild) && child !== secondChild;
            }).map(function (secondChild) {
              return {
                lang: secondChild.replace(/\.[^\.]*$/, "").replace(/^[^\.]*\./, ""),
                text: fs.readFileSync(path.join(translationPath, secondChild), 'utf8')
              };
            })
          };
        }).forEach(function (translation) {
          strings[translation.name] = translation.defaultText;
          translations[translation.defaultText] = {};
          translation.translations.forEach(function (lang) {
            translations[translation.defaultText][lang.lang] = lang.text;
          });
        });
      }
      pathChildren = fs.readdirSync(currDir);
      for (var child in pathChildren) {
        var childPath = path.resolve(path.join(currDir, pathChildren[child]));
        if (fs.statSync(childPath).isDirectory()) {
          var tempArray = getTranslations(childPath, translations, strings);
          translations = tempArray[0];
          strings = tempArray[1];
        }
      }
    } else {
      throw new Error("Translation Path Invalid");
    }
    return [translations, strings];
  }
  function validateTranslations(newTranslations) {
    if (typeof newTranslations !== "object") {
      return false;
    }
    for (var translation in newTranslations) {
      if (typeof translation !== "string") {
        return false;
      }
      if (typeof newTranslations[translation] !== "object") {
        return false;
      }
      for (var lang in newTranslations[translation]) {
        if (typeof lang !== "string") {
          return false;
        }
        if (typeof newTranslations[translation][lang] !== "string") {
          return false;
        }
      }
    }
    return true;
  }
  this.loadTranslations = function (newTranslations) {
    if (typeof newTranslations === "string") {
      var tempArray = getTranslations(newTranslations, {}, this.strings);
      newTranslations = tempArray[0];
      this.strings = tempArray[1];
    }
    if (validateTranslations(newTranslations)) {
      translations = mergeObjs(translations, newTranslations);
    } else {
      throw new Error("Must provide a valid set of translations.");
    }
  };
  this.loadTranslations(translations);
  this.clearTranslations = function () {
    translations = {};
  };
  this.getTranslations = function (textArr) {
    if (textArr instanceof Array) {
      var outObj = {};
      textArr.forEach(function (text) {
        outObj[text] = translations[text];
      });
      return outObj;
    } else {
      return translations;
    }
  };
  this.throwOnMissingTranslation = function (shouldThrow) {
    missingTranslationThrow = !!shouldThrow;
  };
  function replaceVariablesWithStrings() {
    var outString = arguments[0];
    for (var i = 1; i < arguments.length; i++) {
      outString = outString.replace(new RegExp("\\$\\[" + i + "\\]", "g"), arguments[i]);
    }
    return outString;
  }
  this.translate = function () {
    const key = arguments[0];
    var text = translations[key] && translations[key][locale] ? translations[key][locale] : null;
    if (!text) {
      text = translations[key] && translations[key][defaultLocale] ? translations[key][defaultLocale] : null;
    }
    if (typeof text !== "string") {
      text = key;
    }
    var newArr = Array.prototype.splice.call(arguments, 1, arguments.length - 1);
    newArr.unshift(text);
    var result = replaceVariablesWithStrings.apply(this, newArr);
    return result || arguments[0];
  };
  function validateDateFormats(dateFormats) {
    if (typeof dateFormats !== "object") {
      return false;
    }
    /* jshint forin: false */
    for (var lang in dateFormats) {
      if (typeof lang !== "string") {
        return false;
      }
      if (typeof dateFormats[lang] !== "object") {
        return false;
      }
      if (!(dateFormats[lang].dayNames instanceof Array)) {
        return false;
      }
      if (!(dateFormats[lang].monthNames instanceof Array)) {
        return false;
      }
      if (typeof dateFormats[lang].masks !== "object") {
        return false;
      }
      if (typeof dateFormats[lang].masks["default"] !== "string") {
        return false;
      }
      if (dateFormats[lang].dayNames.length !== 14) {
        return false;
      }
      if (dateFormats[lang].monthNames.length !== 24) {
        return false;
      }
      for (var i = 0; i < 24; i++) {
        if (i < 14 && typeof dateFormats[lang].dayNames[i] !== "string") {
          return false;
        }
        if (typeof dateFormats[lang].monthNames[i] !== "string") {
          return false;
        }
      }
    }
    return true;
  }
  this.loadDateFormats = function (newDateFormats) {
    if (validateDateFormats(newDateFormats)) {
      dateFormats = mergeObjs(dateFormats, newDateFormats);
    } else {
      throw new Error("Invalid Date Format provided");
    }
  };
  this.clearDateFormats = function () {
    dateFormats = {
      "en": {
        dayNames: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        monthNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        masks: {
          "default": "ddd mmm dd yyyy HH:MM:ss",
          shortDate: "m/d/yy",
          mediumDate: "mmm d, yyyy",
          longDate: "mmmm d, yyyy",
          fullDate: "dddd, mmmm d, yyyy",
          shortTime: "h:MM TT",
          mediumTime: "h:MM:ss TT",
          longTime: "h:MM:ss TT Z",
          isoDate: "yyyy-mm-dd",
          isoTime: "HH:MM:ss",
          isoDateTime: "yyyy-mm-dd'T'HH:MM:ss",
          isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
        }
      }
    };
  };
  this.getDateFormats = function () {
    return dateFormats;
  };
  if (validateDateFormats(dateFormats)) {
    this.loadDateFormats(dateFormats);
  } else {
    this.clearDateFormats();
  }
  this.localDate = function () {
    var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
      timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
      timezoneClip = /[^-+\dA-Z]/g,
      pad = function (val, len) {
        val = String(val);
        len = len || 2;
        while (val.length < len) val = "0" + val;
        return val;
      };
    return function (date, mask, utc) {
      if (arguments.length === 1 && Object.prototype.toString.call(date) === "[object String]" && !/\d/.test(date)) {
        mask = date;
        date = undefined;
      }
      date = date || new Date();
      if (!(date instanceof Date)) {
        date = new Date(date);
      }
      if (isNaN(date)) {
        throw new TypeError("Invalid date");
      }
      mask = String(dateFormats[locale].masks[mask] || mask || dateFormats[locale].masks["default"]);
      if (mask.slice(0, 4) === "UTC:") {
        mask = mask.slice(4);
        utc = true;
      }
      var _ = utc ? "getUTC" : "get",
        d = date[_ + "Date"](),
        D = date[_ + "Day"](),
        m = date[_ + "Month"](),
        y = date[_ + "FullYear"](),
        H = date[_ + "Hours"](),
        M = date[_ + "Minutes"](),
        s = date[_ + "Seconds"](),
        L = date[_ + "Milliseconds"](),
        o = utc ? 0 : date.getTimezoneOffset(),
        flags = {
          d: d,
          dd: pad(d),
          ddd: dateFormats[locale].dayNames[D],
          dddd: dateFormats[locale].dayNames[D + 7],
          m: m + 1,
          mm: pad(m + 1),
          mmm: dateFormats[locale].monthNames[m],
          mmmm: dateFormats[locale].monthNames[m + 12],
          yy: String(y).slice(2),
          yyyy: y,
          h: H % 12 || 12,
          hh: pad(H % 12 || 12),
          H: H,
          HH: pad(H),
          M: M,
          MM: pad(M),
          s: s,
          ss: pad(s),
          l: pad(L, 3),
          L: pad(L > 99 ? Math.round(L / 10) : L),
          t: H < 12 ? "a" : "p",
          tt: H < 12 ? "am" : "pm",
          T: H < 12 ? "A" : "P",
          TT: H < 12 ? "AM" : "PM",
          Z: utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
          o: (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
          S: ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 !== 10) * d % 10]
        };
      return mask.replace(token, function ($0) {
        return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
      });
    };
  }();
  return this;
}
Localize.source = Localize.toString();
module.exports = Localize;